import { Component, OnInit, Input, Optional, Inject } from "@angular/core";
import { ConfirmDialogComponent } from "src/app/services/dialog/confirm-dialog/confirm-dialog.component";
import { DialogService, LanguageService, HelperService } from "src/app/services";
import { PATTERN_ALPHA_NUMERIC_WITH_SPACE } from "src/app/utils/constant";
import { GroupMaintenanceService } from "../group-maintenance.service";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import { _getOptionScrollPosition } from "@angular/material/core";
import { finalize, retry, catchError } from "rxjs/operators";
import { environment } from "src/environments/environment";
import { MediaObserver } from "@angular/flex-layout";
import { of as observableOf } from 'rxjs';
import * as moment from 'moment';
import * as _ from "lodash";

@Component({
  selector: 'esc-grp-mnt-detail-modal',
  templateUrl: './grp-mnt-detail-modal.component.html',
  styleUrls: ['./grp-mnt-detail-modal.component.scss']
})
export class GrpMntDetailModalComponent implements OnInit {
  @Input() mode;
 
  loading = {
    islandGroup: false,
    district: false,
    groupType:false
  }
  public getMore = true;
  public islandGroups = [];
  public districts = [];
  public groupTypes = [];
  public islandGroupRequired;
  public districtRequired;
  public groupTypeRequired;
  public networkErrMsg = this.languageService.getTranslation("MSG_ERROR_NETWORK_CONNECTION", {});
  public isFormDisabled = false;

  constructor(
    private fb: FormBuilder,
    public helper: HelperService,
    public media: MediaObserver,
    private dialogService: DialogService,
    private languageService: LanguageService,
    private grpMntService: GroupMaintenanceService,
    public dialogRef: MatDialogRef<GrpMntDetailModalComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  public formGroup: FormGroup;
 
  ngOnInit() {
    this.initForm();
    // console.log(this.data)
  }
 
  initForm() {
    let islandGroup = {}, 
    district = {}, 
    groupType = {};
    if(_.get(this.data, "island_group_description")) {
      islandGroup["id"] = _.get(this.data, "island_group_id");
      islandGroup["code"] = _.get(this.data, "island_group_code");
      islandGroup["description"] = _.get(this.data, "island_group_description");
    } else {
      islandGroup = null;
    }
    if(_.get(this.data, "district_description")) {
      district["id"] = _.get(this.data, "district_id");
      district["code"] = _.get(this.data, "district_code");
      district["description"] = _.get(this.data, "district_description");
    } else {
      district = null;
    }
    if(_.get(this.data, "group_type_description")) {
      groupType["id"] = _.get(this.data, "group_type_id");
      groupType["code"] = _.get(this.data, "group_type_code");
      groupType["description"] = _.get(this.data, "group_type_description");
    } else {
      groupType = null;
    }

    this.formGroup = this.fb.group({
      code: [_.get(this.data, "code"), [Validators.required, Validators.maxLength(20), Validators.pattern(PATTERN_ALPHA_NUMERIC_WITH_SPACE)]],
 
      description: [_.get(this.data, "description"), [Validators.required, Validators.maxLength(250)]],
 
      islandGroup: [islandGroup, [Validators.required]],

      district: [district],

      groupType: [groupType, [Validators.required]],
 
      status: _.get(this.data, "is_active") == 1 ? true : false
    });
 
    this.toggleDisable();
  }
 
  toggleDisable() {
    if (!this.data) {
      this.isFormDisabled = false;
      this.formGroup.get("status").disable({ emitEvent: false });
      this.formGroup.get("status").setValue(true);
    } else {
      this.isFormDisabled = true;
      this.formGroup.disable();
      this.formGroup.get('status').enable({ emitEvent: false})
      // this.formGroup.get("code").disable({ emitEvent: false });
      // this.formGroup.get("description").disable({ emitEvent: false });
    }
  }

  isFormValid() {
    if(this.formGroup.valid) {
      this.saveChanges();
    }
    else {
      for (let ctrl in this.formGroup.controls) {
        if(!this.formGroup.controls[ctrl].valid) {
          this[ctrl+"Required"] = true;
        }
      }
    }
  }
 
  saveChanges() {
    let loadingDialog = this.dialogService.loading();
    this.formGroup.disable({ emitEvent: false });
    let is_active = _.get(this.formGroup.get("status"), "value") ? 1 : 0;

    let obj = {
      data: [
        {
          id: _.get(this.data, "id") || 0,
 
          code: _.trim(_.toUpper(_.get(this.formGroup.get("code"), "value"))),
 
          description: _.trim(_.toUpper(_.get(this.formGroup.get("description"), "value"))),

          island_group_id: _.get(this.formGroup.get("islandGroup"), "value.id"),

          district_id: _.get(this.formGroup.get("district"), "value.id") || null,

          group_type_id: _.get(this.formGroup.get("groupType"), "value.id"),
          
          is_active: is_active
        }
      ]
    };

    let tempObj = _.get(this, 'data');
    // tempObj.is_active = is_active;
    let returnObj = tempObj || _.get(obj, "data");
    // returnObj.is_active = is_active;

    this.grpMntService.insert(obj).pipe(
      finalize(() => {
        loadingDialog.close();
        this.formGroup.enable();
        this.toggleDisable();
      })
    )
    .subscribe(
      (res: any) => {
        if (environment.showLogs) {
          console.log(res);
        }

        if (_.has(res, 'status') && _.get(res, 'status') == 0) {
          this.helper.networkErrorMessage();
          return;
        }

        if(this.helper.displayErrorMessage(res)) return;

        if (_.get(res, 'success.count') > 0) {
          this.dialogService.openSnackBar(this.languageService.getTranslation("MSG_DATA_UPDATED", {}));
          this.close(returnObj);
        }
      },
      err => {
        console.log(err);
      }
    );
  }

  disableSaveBtn() {
    return (this.formGroup.touched && !this.formGroup.valid)
  }

  confirmChanges() {
    if(this.formGroup.touched && this.formGroup.valid) {
      this.dialogService.openDialog(ConfirmDialogComponent, {
        width: "400px",
        autoFocus: true,
        disableClose: true,
        data: {
          title: this.languageService.getTranslation("MSG_CONFIRM_ACTION", {}),
          message: this.languageService.getTranslation("MSG_SAVE_CHANGES", {}),
          button: this.languageService.getTranslation("LABEL_YES", {}),
          cancelButton: this.languageService.getTranslation("LABEL_NO", {}),
        }
      })
      .afterClosed()
      .subscribe(result => {
        if(result) {
          this.saveChanges();
        } else {
          this.close(false);
        }
      })
    }
    else {
      this.close(false);
    }
  }
  
  getData(ev) {
    let filters = _.get(ev, 'filters')

     filters.limit = 50
     filters.offset = 0
     filters.keyword = ""

    /*
    * lagay mo dito kung merong i-cascade na parameters for each field
    */
   
    this[_.get(ev, 'arrayName')] = [];

    this.getMore = false;
   
    switch (_.get(ev, 'name')) {
      case "islandGroup": {
        this.loading.islandGroup = true;
        filters.keyword = _.get(this.formGroup.get('islandGroup'), 'value')
        this.grpMntService.getIslandGroup(filters).pipe(
          retry(-1),
          catchError((err) => {
            this.loading.islandGroup = false;
            this.dialogService.openSnackBar(this.languageService.getTranslation("MSG_ERROR_LOADING", {}));
            return observableOf(err);
          }))
          .subscribe((res: any) => {
            if (environment.showLogs) {
              console.log(res);
            }
            this.loading.islandGroup = false;
            if (res == null || res.status == 0 || res.status == 504 || res.status == 500) {
              this.dialogService.openSnackBar(this.networkErrMsg)
              return;
            }
            //get more if response isn't empty
            if (_.has(res, 'data') && res.data.length > 0) {
              // gagamitin lang kung may "All"
              // if(!this.formGroup.get('islandGroup').value) {
              //   this.islandGroups[0] = this.status[0];
              // }
              this.islandGroups = this.islandGroups.concat(res.data);
              this.getMore = true;
            }
          });
        break;
      }

      case "district": {
        this.loading.district = true;
        filters.keyword = _.get(this.formGroup.get('district'), 'value')
        this.grpMntService.getDistrict(filters).pipe(
          retry(-1),
          catchError((err) => {
            this.loading.district = false;
            this.dialogService.openSnackBar(this.languageService.getTranslation("MSG_ERROR_LOADING", {}));
            return observableOf(err);
          }))
          .subscribe((res: any) => {
            if (environment.showLogs) {
              console.log(res);
            }
            this.loading.district = false;
            if (res == null || res.status == 0 || res.status == 504 || res.status == 500) {
              this.dialogService.openSnackBar(this.networkErrMsg)
              return;
            }
            //get more if response isn't empty
            if (_.has(res, 'data') && res.data.length > 0) {
              // gagamitin lang kung may "All"
              // if(!this.formGroup.get('islandGroup').value) {
              //   this.islandGroups[0] = this.status[0];
              // }
              this.districts = this.districts.concat(res.data);
              this.getMore = true;
            }
          });
        break;
      }

      case "groupType": {
        this.loading.groupType = true;
        filters.keyword = _.get(this.formGroup.get('groupType'), 'value')
        this.grpMntService.getGroupType(filters).pipe(
          retry(-1),
          catchError((err) => {
            this.loading.groupType = false;
            this.dialogService.openSnackBar(this.languageService.getTranslation("MSG_ERROR_LOADING", {}));
            return observableOf(err);
          }))
          .subscribe((res: any) => {
            if (environment.showLogs) {
              console.log(res);
            }
            this.loading.groupType = false;
            if (res == null || res.status == 0 || res.status == 504 || res.status == 500) {
              this.dialogService.openSnackBar(this.networkErrMsg)
              return;
            }
            //get more if response isn't empty
            if (_.has(res, 'data') && res.data.length > 0) {
              // gagamitin lang kung may "All"
              // if(!this.formGroup.get('islandGroup').value) {
              //   this.islandGroups[0] = this.status[0];
              // }
              this.groupTypes = this.groupTypes.concat(res.data);
              this.getMore = true;
            }
          });
        break;
      }
    }
  }

  islandGroupSelected(ev) {
    // console.log(ev);
    this.formGroup.get('islandGroup').setValue(ev);
    this.formGroup.get('islandGroup').markAsTouched();
  }

  districtSelected(ev) {
    // console.log(ev);
    this.formGroup.get('district').setValue(ev);
    this.formGroup.get('district').markAsTouched();
  }

  groupTypeSelected(ev) {
    this.formGroup.get('groupType').valueChanges.subscribe(val => {
      this.districtSelected(null);
      if(_.get(val, 'is_required_district') == 1) {
        this.districtRequired = true;
        this.formGroup.get('district').setValidators([
          Validators.required
        ]);
        this.formGroup.get('district').setErrors({ required: true });
      }
      else {
        this.districtRequired = false;
        this.formGroup.get('district').setValidators(null);
      }
    })


    this.formGroup.get('groupType').setValue(ev);
    this.formGroup.get('groupType').markAsTouched();
  }

  reset() {
    this.formGroup.reset();
    
    this.formGroup.setValue({
      // LAGAY MO DITO UNG IBANG CONTROLS and default values nila
      islandGroup: null,
    })

  }
 
  close(data) {
    if(data) {
      this.dialogRef.close(data);
    } else {
      this.dialogRef.close(false);
    }
  }
}